<template functional>
  <button
    :class="$style.ActionListButton"
    type="button"
    :disabled="props.disabled"
    v-on="listeners"
  >
    <template v-if="props.helpText">
      <div>
        <div>{{props.label}}</div>
        <TextStyle type="subdued">{{props.helpText}}</TextStyle>
      </div>
    </template>
    <template v-else>
      {{props.label}}
    </template>
    <Icon
      v-if="props.dropdown"
      icon="fa fa-caret-right"
      style="margin-left: 10px"
    />
  </button>
</template>

<script>
import {Icon} from '../Icon'
import {TextStyle} from '../TextStyle'

export default {
  compoments: {
    Icon,
    TextStyle
  },
  props: {
    label: {
      type: String
    },
    helpText: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropdown: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" module>
@import "../../styles/variables";

.ActionListButton {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  background: #fff;
  border: 0;
  font-size: 14px;
  text-align: left;

  &:not(:disabled) {
    &:hover {
      background: #f5f6f8;
      cursor: pointer;
    }
    &:active {
      background: #e5f0ff;
    }
    &:focus {
      outline: 0;
    }
  }

  &:disabled {
    color: $buttonDisabledTextColor;
  }
}
</style>
